import Generic from 'src/models/generic/Generic'
import InventoryItemUnit from 'src/models/inventory-item/InventoryItemUnit'
import InventoryRecipeItem from 'src/models/inventory-recipe/InventoryRecipeItem'
import ItemClass from 'src/models/item/ItemClass'
import Model, { encoders, ID, JsonArray, JsonObject, MODEL_LEVEL } from 'src/models/model'
import Archivable from 'src/models/model/concerns/Archivable'
import Librariable from 'src/models/model/concerns/Librariable'

export default class InventoryItem extends Model {
  static name = 'InventoryItem'

  static level = MODEL_LEVEL.SITE
  static isConfiguration = true

  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Inventory]

  static define () {
    this.concerns = [Archivable, Librariable]

    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      itemClass: {
        type: ItemClass,
        required: true,
        encode: encoders.hasOne,
        reference: true
      },
      baseUnit: {
        type: String,
        required: true
      },
      cost: {
        type: Number,
        encode: encoders.centsHundredths,
        default: null
      },
      isPreparation: {
        type: Boolean,
        default: false,
        output: true
      },
      balanceByLocation: {
        type: JsonArray,
        default: null,
        excludeFromDefault: true,
        output: true
      },
      balancesByLocationAndRegisterStation: {
        type: JsonObject,
        default: null,
        excludeFromDefault: true,
        output: true
      },
      inventoryItemUnits: {
        type: [InventoryItemUnit],
        acceptsNestedAttributes: true,
        allowDestroy: true
      },
      inventorySupplierIds: {
        type: [ID],
        default: () => ([])
      },
      inventoryRecipeItems: {
        type: [InventoryRecipeItem],
        output: true,
        excludeFromDefault: true
      },
      action: {
        type: String,
        input: true
      }
    }

    this.computed = {
      baseInventoryItemUnit () {
        return _(this.inventoryItemUnits.data).filter(unit => unit.baseQuantity === 1).first()
      },
      isBaseUnitReadonly () {
        return this.isRemote
      }
    }

    this.queries = {
      inventoryItemBalancesByLocationAndRegisterStation: {
        arguments: {
          effectiveAt: {
            type: String,
            required: true
          },
          locationId: {
            type: ID,
            required: false
          },
          registerStationId: {
            type: ID,
            required: false
          },
          force: {
            type: Boolean,
            required: false
          }
        },
        results: {
          value: Generic
        }
      }
    }

    this.paginate = true
  }
}
